<template>
    <div class="flex flex-col gap-4">
        <p class="cambay-bold  mb-3 text-gray-700">{{ title }}</p>
        <div class="flex flex-wrap gap-1">
            <button
                v-for="preset in presetSizes"
                :key="preset"
                :class="{'btn-outline': size !== preset, 'bg-gray-900 text-white': size === preset}"
                @click="$emit('update:size', preset)"
                class="btn btn-sm px-2">{{ preset }}cm
            </button>
            <div class="flex flex-row relative" v-if="!presetSizes.includes(size)">
                <button class="btn bg-gray-900 text-white btn-sm px-2 tooltip">
                    {{ size }}cm
                </button>
            </div>

        </div>
        <div class="flex flex-row gap-1">
            <button class="btn btn-sm btn-circle" @click="decrementSize">
                <i class="fa-solid fa-minus"></i>
            </button>
            <input type="range" :min="min" :max="max" v-model="localSize"
                   class="range range-xs range-accent w-3/4 md:w-full mt-2" @input="emitRangeUpdate"/>
            <button class="btn btn-sm btn-circle" @click="incrementSize">
                <i class="fa-solid fa-plus"></i>
            </button>
        </div>
    </div>
</template>

<script>
import {ref, watch, defineComponent} from 'vue';
import Money from "@/Components/Money.vue";

export default defineComponent({
    components: {Money},
    props: {
        title: String,
        size: Number,
        presetSizes: Array,
        min: Number,
        max: Number
    },
    setup(props, {emit}) {
        const localSize = ref(props.size);

        const updateSize = () => {
            emit('update:size', localSize.value);
        };

        const emitRangeUpdate = () => {
            emit('range:update:size', localSize.value);
        };

        const decrementSize = () => {
            if (localSize.value > props.min) {
                localSize.value--;
                updateSize();
            }
        };

        const incrementSize = () => {
            if (localSize.value < props.max) {
                localSize.value++;
                updateSize();
            }
        };

        watch(() => props.size, newSize => {
            localSize.value = newSize;
        });

        return {
            localSize,
            updateSize,
            emitRangeUpdate,
            decrementSize,
            incrementSize
        };
    }
});
</script>
